import type { ISideDownloadCta } from '../types';

export const hasSideDownloadCtaData = ({
  bodyCopy = '',
  buttons = [],
  headline = '',
  thumbnail,
}: ISideDownloadCta) => (
  bodyCopy ||
  (buttons?.length > 0) ||
  headline ||
  (Object.keys(thumbnail || {}).length > 0)
);
